import React, { useEffect, useState } from 'react';
import {
	Modal,
	Tag,
} from 'antd';
import {
	CloseOutlined,
} from '@ant-design/icons';
import DevicesService from '../../domain/Devices/DevicesService';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
import { iotEventsService } from '../../events/iot-events.subject';
import { IotDevice } from '@/domain/Devices/Iot';
import useDebounce from '@/hooks/useDebounce';

import {
	Search,
	DataGrid,
	Button,
} from '@hydrodigital/design-system';

const devicesService = new DevicesService();

export default function StatusDevice() {
	const [bulkList, setBulkList] = useState<any[]>([]);
	const [paginationState, setPaginationState] = useState({
		pageIndex: 0,
		pageSize: 10,
	});
	const [totalRows, setTotalRows] = useState(0);
	const [query, setQuery] = useState<string>('');
	const [messageError, setMessageError] = useState('');
	const [showErrorInfoModal, setShowErrorInfoModal] = useState(false);
	const [selectedIot, setSelectedIot] = useState<IotDevice | null>(null);
	const [messagesIot, setmessagesIot] = useState<null | any[]>(null);
	const [showIotDetails, setShowIotDetails] = useState(false);
	const subscriptionIot$ = iotEventsService.getSubject();
	const navigate = useNavigate();

	const debouncedQuery = useDebounce(query, 500);

	const gridColumns = [
		{
			header: 'File Name',
			accessorKey: 'name',
			cell: ({ cell }: any) => <span className="table-data-gis">{cell.getValue()}</span>,
		},
		{
			header: 'Latitude',
			accessorKey: 'latitude',
			cell: ({ cell }: any) => <span className="table-data-gis">{cell.getValue()}</span>,
		},
		{
			header: 'Longitude',
			accessorKey: 'longitude',
			cell: ({ cell }: any) => <span className="table-data-gis">{cell.getValue()}</span>,
		},
		{
			header: 'Upload for',
			id: 'uploadFor',
			cell: ({ row }: any) => {
				const record = row.original;
				return (
					<div className="flex column">
						<span style={{ color: '#232B36', fontSize: '14px', fontWeight: '500' }}>
							{record.createdBy}
						</span>
						<span style={{ color: '#74788D' }}>
							{dayjs(record.createdAt).format('YYYY/MM/DD [at] hh:mm a')}
						</span>
					</div>
				);
			},
		},
		{
			header: 'Status',
			id: 'status',
			cell: ({ row }: any) => {
				const record = row.original;
				const color =
					record.status === 'COMPLETED' ? 'green' : record.status === 'FAILED' ? 'red' : 'orange';
				return (
					<span>
						<Tag color={color} style={{ borderRadius: '20px' }}>
							{record.status}
						</Tag>
					</span>
				);
			},
		},
		{
			header: 'Send status',
			id: 'actions',
			cell: ({ row }: any) => {
				const record = row.original;
				return (
					<div className="flex">
						{record.statusMessage === 'SENDING' && (
							<Tag color={'orange'} style={{ borderRadius: '20px' }}>
								{record.statusMessage}
							</Tag>
						)}
						{record.statusMessage === 'ERROR' && (
							<Tag color={'red'} style={{ borderRadius: '20px' }}>
								{record.statusMessage}
							</Tag>
						)}
						{record.statusMessage !== 'SENDING' && record.statusMessage !== 'ERROR' && (
							<span
								style={{
									color: '#22A2CA',
									textDecoration: 'underline',
									cursor: 'pointer',
								}}
								onClick={() => {
									getMessages(record.iotUploadId);
								}}
							>
								View sends
							</span>
						)}
					</div>
				);
			},
		},
	];
	const columnsDetail = [
		{
			header: 'Message',
			accessorKey: 'iotMessage',
			width: 300,
		},
		{
			header: 'Date',
			id: 'date',
			width: 300,
			cell: ({ row }: any) => {
				const record = row.original;
				return (
					<span style={{ color: '#74788D' }}>
						{dayjs(record.createdAt).format('YYYY/MM/DD [at] hh:mm a')}
					</span>
				);
			},
		},
		{
			header: 'Sending by',
			accessorKey: 'createdBy',
			width: 300,
		},
	];

	const getDevices = async () => {
		const oui = JSON.parse(localStorage.getItem('security') || '{}').organizationId;
		const response = await devicesService.getIotByOrganization(
			oui,
			paginationState.pageIndex + 1,
			paginationState.pageSize,
			debouncedQuery || null,
		);
		console.log('🚀 ~ file: index.tsx:126 ~ getDevices ~ response:', response);
		setBulkList(response.data);
		setTotalRows(response.totalRecords);
	};

	const getMessages = async (iotId: string | number) => {
		const response = await devicesService.getMessagesByIot(iotId);
		console.log('🚀 ~ file: StatusDevice.tsx:175 ~ getMessages ~ response:', response);
	};

	const handleDeleteIot = async (iotId: string | number) => {
		const response = await devicesService.deleteIot(iotId);
		console.log('🚀 ~ file: index.tsx:143 ~ handleDeleteIot ~ response:', response);
	};

	useEffect(() => {
		subscriptionIot$.subscribe((event) => {
			if (event.type == 'iotUploaded') {
				console.log(event);
				setBulkList((prev) =>
					prev.map((item) =>
						item.id === event.data.id ? { ...item, status: event.data.status } : item,
					),
				);
			}
		});
	}, []);

	useEffect(() => {
		getDevices();
	}, [paginationState.pageIndex, paginationState.pageSize, debouncedQuery]);

	useEffect(() => {
		setPaginationState((prev) => ({ ...prev, pageIndex: 0 }));
	}, [debouncedQuery]);

	return (
		<div className="flex flex-col" style={{ height: 'calc(100vh - 220px)' }}>
			{bulkList.length > 0 ? (
				<>
					<div className="flex justify-between mb-3" style={{ flexShrink: 0 }}>
						<div style={{ width: 200, minWidth: 200 }}>
							<Search
								placeholder="Search"
								size="small"
								value={query}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
									setQuery(e.target.value);
								}}
								showClearButton={true}
								onClear={() => {
									setQuery('');
								}}
								style={{ width: '100%' }}
							/>
						</div>
					</div>

					<DataGrid
						data={bulkList}
						columns={gridColumns}
						stickyHeader={true}
						maxHeight="calc(100vh - 380px)"
						pagination={{
							enabled: true,
							manualPagination: true,
							rowCount: totalRows,
							defaultPageSize: 10,
							pageSizeOptions: [10, 20, 50],
						}}
						paginationState={paginationState}
						onPaginationChange={setPaginationState}
					/>
				</>
			) : (
				<div
					className="flex column items-center justify-center"
					style={{ height: 'calc(100vh - 300px)' }}
				>
					<span style={{ fontSize: '16px' }} className="text-center">
						Whoops looks like you have nothing here. <br />
						Start by clicking here
					</span>
					<Button
						variant="primary"
						size="small"
						label="Upload IOT Files"
						iconName="plus-circle"
						iconColor="white"
						onClick={() => {
							navigate(`/bulk/upload`);
						}}
					/>
				</div>
			)}
			<Modal open={showIotDetails} footer={[]} closable={false} width={800}>
				<div className="flex column">
					<div className="flex justify-between">
						<span
							className="mb-2"
							style={{
								color: '#023E65',
								fontSize: '1.2rem',
								fontWeight: 'bold',
							}}
						>
							{`${selectedIot?.name} DEVICES`}
						</span>
						<CloseOutlined
							className="mb-auto"
							style={{ fontSize: '20px', cursor: 'pointer' }}
							onClick={() => {
								setShowIotDetails(false);
							}}
							rev={undefined}
						/>
					</div>
					<div className="separator mb-2" />
					<DataGrid
						columns={columnsDetail}
						data={messagesIot || []}
						maxHeight="calc(100vh - 300px)"
						pagination={{
							enabled: false,
						}}
					/>
				</div>
			</Modal>
		</div>
	);
}
